import { render, staticRenderFns } from "./CustomFieldValueChip.vue?vue&type=template&id=3805f5c0"
import script from "./CustomFieldValueChip.vue?vue&type=script&lang=ts"
export * from "./CustomFieldValueChip.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports